/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Offcanvas } from 'react-bootstrap';
import { FiInfo, FiFileText, FiCheckCircle } from 'react-icons/fi';
// import { DEFAULT_REQUIRED_DOCUMENTS } from '../../constants/onlineVisaConstants';
import './RequiredDocuments.scss';

// Normalise a document entry to a common shape regardless of whether it comes
// from the GETREQUIREDDOCUMENTS API or from DEFAULT_REQUIRED_DOCUMENTS.
const normaliseDoc = (doc, index) => {
  if (!doc) return null;
  if (doc.documentName || doc.documentContent) {
    return {
      id: doc.documentNumber || doc.documentId || `doc-${index}`,
      label: doc.documentName || `Document ${index + 1}`,
      content: Array.isArray(doc.documentContent)
        ? doc.documentContent
        : doc.documentContent
        ? [doc.documentContent]
        : [],
      url: doc.documentUrl || '',
      format: doc.documentFormat || '',
    };
  }
  return {
    id: doc.key || doc.label || `doc-${index}`,
    label: doc.label || `Document ${index + 1}`,
    content: doc.hint ? [doc.hint] : [],
    url: '',
    format: '',
  };
};

function RequiredDocuments({ documents, loading }) {
  const list = useMemo(() => {
    const src = Array.isArray(documents) ? documents : [documents];
    return src.map((d, i) => normaliseDoc(d, i)).filter(Boolean);
  }, [documents]);

  const [openDoc, setOpenDoc] = useState(null);

  const handleOpen = (doc) => setOpenDoc(doc);
  const handleClose = () => setOpenDoc(null);

  return (
    <aside className="required-documents">
      <h3 className="required-documents__title">Required Documents</h3>
      <span className="required-documents__title-underline" aria-hidden />

      {loading ? (
        <div className="required-documents__loader">
          <div className="required-documents__skeleton" />
          <div className="required-documents__skeleton" />
          <div className="required-documents__skeleton" />
        </div>
      ) : (
        <ul className="required-documents__list">
          {list.map((doc) => (
            <li key={doc.id} className="required-documents__item">
              <span className="required-documents__label">{doc.label}</span>
              <button
                type="button"
                className="required-documents__info"
                aria-label={`Info about ${doc.label}`}
                title={`Details for ${doc.label}`}
                onClick={() => handleOpen(doc)}
              >
                <FiInfo />
              </button>
            </li>
          ))}
        </ul>
      )}

      <Offcanvas
        show={!!openDoc}
        onHide={handleClose}
        placement="end"
        className="required-documents__offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="required-documents__offcanvas-title">
            <FiFileText />
            <span>{openDoc?.label || 'Document details'}</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {openDoc?.content && openDoc.content.length > 0 ? (
            <ul className="required-documents__detail-list">
              {openDoc.content.map((line, idx) => (
                <li
                  // eslint-disable-next-line react/no-array-index-key
                  key={idx}
                  className="required-documents__detail-item"
                >
                  <FiCheckCircle />
                  <span>{line}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="required-documents__detail-empty">
              No additional details available for this document.
            </p>
          )}
          {openDoc?.url && (
            <a
              href={openDoc.url}
              target="_blank"
              rel="noopener noreferrer"
              className="required-documents__detail-link"
            >
              Download sample
            </a>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </aside>
  );
}

RequiredDocuments.propTypes = {
  documents: PropTypes.array,
  loading: PropTypes.bool,
};

RequiredDocuments.defaultProps = {
  documents: null,
  loading: false,
};

export default RequiredDocuments;
